import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { useDirectedVideoContext } from '../../DirectedVideoContext';
import { resultMessages as messages } from '../../messages/resultMessages';
import { directedResultStills } from './resultRules';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the result; each part uses its own slice of it */
import styles from './Result.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The stills that the strip shows; the rest is one "+N" tile (design k1). */
const SHOWN_STILLS = 9;

/** The stills of the new clips under the player (design directed-video k1). Hidden on a phone. */
const ResultClipStripComponent: React.FC<{ clipsMade: number }> = ({ clipsMade }) => {
  const intl = useIntl();
  const { video } = useDirectedVideoContext();
  const stills = useMemo(() => directedResultStills(video), [video]);
  const shown = useMemo(() => stills.slice(0, SHOWN_STILLS), [stills]);
  if (shown.length === 0) {
    return null;
  }
  const rest = stills.length - shown.length;
  return (
    <div className={styles.clips}>
      <span className={styles.eyebrow}>{intl.formatMessage(messages.clipsEyebrow, { count: clipsMade })}</span>
      <ul className={styles.strip} data-testid="directed-result-strip">
        {shown.map((url) => (
          <li key={url}>
            <img src={url} alt="" loading="lazy" />
          </li>
        ))}
        {rest > 0 && <li className={styles.more}>{intl.formatMessage(messages.more, { count: rest })}</li>}
      </ul>
    </div>
  );
};

export const ResultClipStrip = TypedMemo(ResultClipStripComponent);
